import { Fragment, useEffect } from 'react'
import { NextSeo } from 'next-seo'

import withPage from '@/lib/page/withPage'

import withServiceLayout from '@/features/Services/layouts/withServiceLayout'
import ServiceSection from '@/features/Services/templates/ServiceSection'
import PriceSection from '@/features/Services/templates/PriceSection'

import { WhatYouGet } from '@/components/Landing'

import { DPA } from '@/features/Services/constants'
import { logEcommerce } from '@/lib/stats/gtm'

function DPAPage() {
  useEffect(() => {
    logEcommerce('view_item', {
      items: [
        {
          item_id: 'Data Processing Agreement',
          item_name: 'Data Processing Agreement',
          quantity: 1,
        },
      ],
    })
  }, [])
  return (
    <Fragment>
      <NextSeo title="Data Processing Agreement" />

      <ServiceSection data={DPA} />
      <PriceSection serviceName="DPA" />
      <WhatYouGet hideDecor primaryColor={DPA.PRIMARY_COLOR} />
    </Fragment>
  )
}

export default withPage()(withServiceLayout(DPAPage))
